import { RATING_REVIEW, RATING_REVIEW_SUMMARY, RATING_AGGREGATION, RATING_TAGS } from 'actions/rating';

const initialState = {
  isLoading: false,
  rating: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
  isAggregationLoading: false,
  aggregation: null,
  tagsList: [],
  isTagsLoading: false,
};

const ratingReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case RATING_REVIEW.REQUEST:
    case RATING_REVIEW_SUMMARY.REQUEST: {
      return { ...state, isLoading: true };
    }
    case RATING_REVIEW.SUCCESS:
    case RATING_REVIEW_SUMMARY.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        rating: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
        avg_rating: payload.avg_rating,
      };
    }

    case RATING_REVIEW.FAIL:
    case RATING_REVIEW_SUMMARY.FAIL: {
      return { ...state, isLoading: false };
    }
    case RATING_AGGREGATION.REQUEST: {
      return { ...state, isAggregationLoading: true, aggregation: null };
    }
    case RATING_AGGREGATION.SUCCESS: {
      return { ...state, isAggregationLoading: false, aggregation: payload };
    }
    case RATING_AGGREGATION.FAIL: {
      return { ...state, isAggregationLoading: false };
    }
    case RATING_TAGS.REQUEST: {
      return { ...state, isTagsLoading: true };
    }
    case RATING_TAGS.SUCCESS: {
      return { ...state, isTagsLoading: false, tagsList: payload };
    }
    case RATING_TAGS.FAIL: {
      return { ...state, isTagsLoading: false };
    }
    default:
      return { ...state };
  }
};
export default ratingReducer;
